var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "YdDialog",
    {
      ref: "activitiesAdd",
      attrs: {
        title: "新建首单优惠",
        visible: _vm.visible,
        "before-close": _vm.handleClose,
        width: "68%",
      },
      on: {
        "update:visible": function ($event) {
          _vm.visible = $event
        },
      },
    },
    [
      _c(
        "el-form",
        {
          ref: "form",
          attrs: {
            model: _vm.form,
            size: "small",
            rules: _vm.rules,
            "label-width": "100px",
          },
        },
        [
          _c(
            "el-form-item",
            { attrs: { label: "活动名称：", prop: "name" } },
            [
              _c("el-input", {
                attrs: {
                  placeholder: "请输入活动名称",
                  clearable: "",
                  maxlength: "20",
                  "show-word-limit": "",
                },
                model: {
                  value: _vm.form.name,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "name", $$v)
                  },
                  expression: "form.name",
                },
              }),
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "活动时间：" } },
            [
              _c("avue-date", {
                attrs: {
                  type: "datetimerange",
                  prop: "datetimerange",
                  format: "yyyy-MM-dd HH:mm:ss",
                  valueFormat: "yyyy-MM-dd HH:mm:ss",
                },
                on: { change: _vm.handleSelectDate },
                model: {
                  value: _vm.dates,
                  callback: function ($$v) {
                    _vm.dates = $$v
                  },
                  expression: "dates",
                },
              }),
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "隶属公司：" } },
            [
              _c(
                "span",
                { staticStyle: { "padding-left": "8px" } },
                [
                  _c(
                    "el-button",
                    {
                      attrs: {
                        type: "primary",
                        size: "mini",
                        disabled: _vm.isDisabled,
                      },
                      on: {
                        click: function ($event) {
                          $event.stopPropagation()
                          return _vm.handleMerchant.apply(null, arguments)
                        },
                      },
                    },
                    [_vm._v("添加")]
                  ),
                ],
                1
              ),
              _c(
                "span",
                { staticStyle: { "padding-left": "10px" } },
                [
                  _c(
                    "el-checkbox",
                    {
                      attrs: { "true-label": "1", "false-label": "0" },
                      on: { change: _vm.handleEnabledChecked },
                      model: {
                        value: _vm.form.isAll,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "isAll", $$v)
                        },
                        expression: "form.isAll",
                      },
                    },
                    [_vm._v("全选")]
                  ),
                ],
                1
              ),
              _vm._l(_vm.merchantLists, function (item, index) {
                return _c("block", { key: index }, [
                  _c("div", { staticClass: "acea-row row-middle" }, [
                    _c("i", {
                      staticClass: "el-icon-remove-outline",
                      on: {
                        click: function ($event) {
                          return _vm.remove(index)
                        },
                      },
                    }),
                    _c("span", { staticClass: "mr5" }, [
                      _vm._v(_vm._s(item.merchantName)),
                    ]),
                  ]),
                  _c(
                    "div",
                    { staticStyle: { "padding-left": "10px" } },
                    [
                      _c("el-card", { staticClass: "box-card" }, [
                        _c(
                          "div",
                          { staticStyle: { padding: "8px" } },
                          _vm._l(item.lineIds, function (citem, index) {
                            return _c("block", { key: index }, [
                              _c(
                                "span",
                                { staticStyle: { margin: "6px" } },
                                [
                                  _c(
                                    "el-checkbox",
                                    {
                                      attrs: {
                                        "true-label": "1",
                                        "false-label": "0",
                                        border: "",
                                      },
                                      model: {
                                        value: citem.check,
                                        callback: function ($$v) {
                                          _vm.$set(citem, "check", $$v)
                                        },
                                        expression: "citem.check",
                                      },
                                    },
                                    [_vm._v(_vm._s(citem.lineName))]
                                  ),
                                ],
                                1
                              ),
                            ])
                          }),
                          1
                        ),
                      ]),
                    ],
                    1
                  ),
                ])
              }),
            ],
            2
          ),
          _c("el-form-item", { attrs: { label: "活动奖励：" } }, [
            _vm._v("\n      减\n      "),
            _c(
              "span",
              [
                _c("avue-input-number", {
                  staticStyle: { width: "10vw" },
                  attrs: { minRows: "0", precision: "2" },
                  model: {
                    value: _vm.form.discountsMoney,
                    callback: function ($$v) {
                      _vm.$set(_vm.form, "discountsMoney", $$v)
                    },
                    expression: "form.discountsMoney",
                  },
                }),
              ],
              1
            ),
            _vm._v("\n      元\n    "),
          ]),
          _c(
            "el-form-item",
            { attrs: { label: "是否可选优惠券：", "label-width": "110" } },
            [
              _c("avue-radio", {
                attrs: {
                  dic: [
                    { label: "是", value: 1 },
                    { label: "否", value: 0 },
                  ],
                },
                model: {
                  value: _vm.form.isChooseCoupon,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "isChooseCoupon", $$v)
                  },
                  expression: "form.isChooseCoupon",
                },
              }),
            ],
            1
          ),
          _vm.form.isChooseCoupon === 1
            ? _c(
                "el-form-item",
                { attrs: { label: "互斥" } },
                [
                  _c(
                    "el-checkbox",
                    {
                      attrs: { "true-label": "0", "false-label": "1" },
                      on: { change: _vm.handleIsUserCoupon },
                      model: {
                        value: _vm.form.isUserCoupon,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "isUserCoupon", $$v)
                        },
                        expression: "form.isUserCoupon",
                      },
                    },
                    [_vm._v("与所有优惠券互斥")]
                  ),
                ],
                1
              )
            : _vm._e(),
        ],
        1
      ),
      _c(
        "div",
        {
          staticClass: "dialog-footer",
          attrs: { slot: "footer" },
          slot: "footer",
        },
        [
          _c(
            "el-button",
            {
              attrs: { size: "small", type: "danger" },
              on: { click: _vm.reset },
            },
            [_vm._v("取 消")]
          ),
          _c(
            "el-button",
            {
              attrs: { type: "primary", size: "small" },
              on: { click: _vm.submit },
            },
            [_vm._v("保 存")]
          ),
        ],
        1
      ),
      _vm.selectMerchantVisible
        ? _c("select-merchant", { ref: "merchant" })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }